module.exports = __webpack_public_path__ + "static/media/loader.c7b798bb.gif";